<template>
    <div class="relative w-full max-w-5xl mx-auto group">
        <div
            class="relative flex items-center bg-white border-1 border-gray-100 rounded-2xl px-1.5 py-1 shadow-sm transition-all focus-within:border-[#1E90FF] focus-within:shadow-md">

            <button @click="toggleEngine"
                class="flex items-center justify-center w-10 h-10 transition-all active:scale-90 group/btn">
                <div class="relative w-4 h-4">
                    <Transition name="slide-up" mode="out-in">
                        <img :key="currentKey" :src="currentEngine.icon"
                            class="w-full h-full rounded-sm object-contain" />
                    </Transition>
                </div>
            </button>

            <div class="w-[1.5px] h-5 bg-gray-100 mx-1"></div>

            <input v-model="searchQuery" @keyup.enter="handleSearch" type="text"
                class="h-[40px] flex-grow bg-transparent border-none outline-none px-3 text-sm text-gray-700 placeholder:text-gray-300 tracking-tight"
                :placeholder="`在 ${currentEngine.name} 中搜索...`" />

            <svg class="w-5 h-5 text-gray-300 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                stroke-width="3">
                <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import bIcon from '@/assets/b.png';
import gIcon from '@/assets/g.png';

const searchQuery = ref('');
const currentKey = ref('baidu'); // 默认百度

const engines = {
    baidu: {
        name: '百度',
        icon: bIcon,
        url: 'https://www.baidu.com/s?wd='
    },
    google: {
        name: 'Google',
        icon: gIcon,
        url: 'https://www.google.com/search?q='
    }
};

const currentEngine = computed(() => engines[currentKey.value]);

// 点击图标直接切换
const toggleEngine = () => {
    currentKey.value = currentKey.value === 'baidu' ? 'google' : 'baidu';
};

const handleSearch = () => {
    const query = searchQuery.value.trim();
    if (!query) return;
    window.open(`${currentEngine.value.url}${encodeURIComponent(query)}`, '_blank');
    searchQuery.value = ''
};
</script>

<style scoped>
/* 图标切换时的位移动画 */
.slide-up-enter-active,
.slide-up-leave-active {
    transition: all 0.2s ease;
}

.slide-up-enter-from {
    opacity: 0;
    transform: translateY(8px) scale(0.8);
}

.slide-up-leave-to {
    opacity: 0;
    transform: translateY(-8px) scale(0.8);
}

/* 移除输入框默认的高亮外框 */
input:focus {
    box-shadow: none;
}
</style>